import { render, staticRenderFns } from "./residenteAdminConfig.vue?vue&type=template&id=b4117970&scoped=true"
import script from "./residenteAdminConfig.vue?vue&type=script&lang=js"
export * from "./residenteAdminConfig.vue?vue&type=script&lang=js"
import style0 from "./residenteAdminConfig.vue?vue&type=style&index=0&id=b4117970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4117970",
  null
  
)

export default component.exports